'use client';

import { For, Stack, Text } from '@chakra-ui/react';

import { APP_ROUTES } from '@/routes';
import { CollectionCard } from '@/modules/products';

import { useRouter } from 'next/navigation';
import { useListCollectionsQuery } from '../../hooks/collections/queries';
import { WebContractListCollectionsQueryParamsSchema } from '@packages/contracts';
import { DefaultStyle, ResponsiveAutoGrid } from '@packages/wastic-shared';
import { useTranslations } from 'next-intl';

const useCollectionList = () => {
	const queryParams = WebContractListCollectionsQueryParamsSchema.parse({ pageSize: 100 });
	const { data } = useListCollectionsQuery(queryParams);

	const router = useRouter();
	const handleGoToCollection = (collectionSlug: string) => {
		const url = APP_ROUTES.SHOP.COLLECTION.replace(':collectionSlug', collectionSlug);
		router.push(url);
	};

	return {
		collections: data?.collections || [],
		handleGoToCollection,
	};
};

const CollectionListContainer = () => {
	const t = useTranslations();
	const { collections, handleGoToCollection } = useCollectionList();

	return (
		<Stack gap={DefaultStyle.SMALL_GAP}>
			<Text as={'h2'} textStyle={'h3'}>
				{t('CollectionListPage.title')}
			</Text>
			<ResponsiveAutoGrid gap={DefaultStyle.TIGHT_GRID_GAP}>
				<For each={collections}>
					{collection => (
						<CollectionCard
							key={`feature-collection-${collection.name}`}
							collection={collection}
							onClick={() => handleGoToCollection(collection.slug)}
						/>
					)}
				</For>
			</ResponsiveAutoGrid>
		</Stack>
	);
};

export default CollectionListContainer;
